import { parsePhoneNumber, type Country } from 'react-phone-number-input';

/**
 * Formats a phone number to the national normal formatting
 *   given the basic number string.
 * @param {string} number
 * @param {boolean} opts.includeCountryCode Whether to include the country code. Defaults to true.
 * @returns Formatted phone number +{CountryCode} {NationalFormattedPhone}
 *   (ie '+1 (319) 431-8574')
 */
export const formatPhone = (
  number: string,
  opts: { includeCountryCode: boolean } = { includeCountryCode: true },
): string => {
  const phoneNumber = parsePhoneNumber(number);
  if (!phoneNumber) {
    return '';
  }

  let formattedPhoneNumber = '';
  if (opts.includeCountryCode) {
    formattedPhoneNumber = `+${phoneNumber.countryCallingCode} `;
  }
  formattedPhoneNumber += `${phoneNumber.formatNational()}`;

  return formattedPhoneNumber;
};

/**
 * Prepare phone number for api submission
 *
 * @param {string} number
 * @param {number} country Code of the country (Assumes US if no value is passed in)
 */
export const serializePhone = (number: string, country: Country = 'US'): string => {
  if (!number || !country) {
    return '';
  }

  const phoneNumber = parsePhoneNumber(number, country);
  return phoneNumber ? phoneNumber.number.toString() : '';
};
